/**
 * New typescript file
 */
import { Component } from '@angular/core';
//import { Router } from '@angular/router';
import { Headers, Http } from '@angular/http';

//import {Router,RouteParams}  from '@angular/router';
import { CommonService} from './service.common';

@Component({
    selector: 'page-footer',
    templateUrl: './html/pageFooter.html'
//    templateUrl: '../html/pageFooter.html'
//     `
//        this is footer
//    `
})
export class PageFooterComponent{

	constructor(
		private commonService: CommonService,
		private http: Http
	) { 
		localStorage.setItem('showDonation', 'f');
	}
	public showDonation:Boolean = false;
	ngOnInit(){
		this.commonService.isAuthencatedIp()
		.then((resp) => {
			this.showDonation = resp;
			if(resp){
				localStorage.setItem('showDonation', 't');
			}
            else{
				localStorage.setItem('showDonation', 'f');
            }

		})

	}
}


// WEBPACK FOOTER //
// ./src/app/pageFooter.ts